<template>
	<div class="air-partners-container">
		<!-- 航空运输 -->
		<section class="service-section air-transport" id="section1">
			<div class="container">
				<div class="section-header center">
					<h2 class="section-title">{{ $t('NavigationServices.airTitle') }}</h2>
					<p class="section-subtitle">{{ $t('NavigationServices.airDescription') }}</p>
				</div>
				<div class="airline-partners">
					<div class="partner-grid">
						<div class="partner-item" v-for="(airline, index) in airlines" :key="index">
							<img v-lazy-img="getLogo(airline.logo)" :alt="airline.name" class="partner-logo" />
							<span class="partner-name">{{ airline.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 海运服务 -->
		<section class="service-section sea-transport">
			<div class="container">
				<div class="section-header center">
					<h2 class="section-title">{{ $t('NavigationServices.seaTitle') }}</h2>
					<p class="section-subtitle">{{ $t('NavigationServices.seaDescription') }}</p>
				</div>
				<div class="shipping-partners">
					<div class="partner-grid">
						<div class="partner-item" v-for="(item, index) in shippingLines" :key="index">
							<img v-lazy-img="getLogo(item.logo)" :alt="item.name" class="partner-logo"
								:style="index === 7 ? { width: '140px' } : {}" />
							<div class="partner-info">
								<span class="partner-name">{{ item.name }}</span>
								<!-- <span class="partner-code">{{ item.code }}</span> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'Shipping',
		data() {
			return {

			};
		},
		computed: {
			airlines() {
				return this.$t('airlines')
			},
			shippingLines() {
				return this.$t('shippingLines')
			}
		},
		methods: {
			getLogo(filename) {
				return require(`@/assets/images/${filename}`);
			}
		}
	};
</script>

<style lang="scss" scoped>
	// === Design System Variables (aligned with Home.vue) ===
	$primary: #0052CC;
	$primary-dark: #0043A8;
	$primary-light: #3B7FFF;
	$silver: #8E9EAB;
	$light: #F4F7FB;
	$body: #5B6C7F;
	$heading: #0A1628;

	.air-partners-container {
		overflow-x: hidden;
		font-family: 'Rubik', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
		color: $body;
	}

	.service-section {
		padding: 30px 0;

		& + .service-section {
			margin-top: 10px;
		}
	}

	.section-header {
		text-align: center;
		margin-bottom: 30px;

		.section-tag {
			display: inline-block;
			font-size: 0.85rem;
			font-weight: 700;
			letter-spacing: 3px;
			text-transform: uppercase;
			color: $primary;
			background: rgba(0, 82, 204, 0.06);
			border: 1px solid rgba(0, 82, 204, 0.12);
			padding: 5px 18px;
			border-radius: 100px;
			margin-bottom: 14px;
		}

		.section-title {
			font-size: 2.6rem;
			font-weight: 700;
			margin: 0 0 12px 0;
			color: $heading;
			letter-spacing: -0.5px;
			line-height: 1.2;

			&::after {
				content: '';
				display: block;
				width: 80px;
				height: 4px;
				background: linear-gradient(to right, $primary, $primary-light);
				border-radius: 2px;
				margin: 12px auto 0;
			}

			@media (max-width: 768px) {
				font-size: 1.8rem;
			}

			@media (max-width: 480px) {
				font-size: 1.5rem;
			}
		}

		.section-subtitle {
			font-size: 0.95rem;
			color: #666;
			max-width: 760px;
			margin: 16px auto 0;
			font-weight: 400;
			line-height: 1.6;
		}
	}

	/* 合作伙伴网格 */
	.partner-grid {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		gap: 18px;
	}

	.partner-item {
		background: #fff;
		border-radius: 8px;
		padding: 15px 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
		transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);

		&:hover {
			transform: translateY(-3px);
			box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
			border-color: rgba(0, 82, 204, 0.25);
		}
	}

	.partner-logo {
		height: clamp(55px, 10vw, 70px);
		width: auto;
		margin-bottom: 10px;
		object-fit: contain;
		transition: transform 0.35s ease;
	}

	.partner-item:hover .partner-logo {
		transform: scale(1.05);
	}

	.partner-name {
		font-weight: 600;
		text-align: center;
		font-size: clamp(0.88rem, 1.6vw, 0.95rem);
		color: #333;
	}

	.partner-info {
		display: flex;
		flex-direction: column;
		text-align: center;
		width: 100%;
	}

	.partner-code {
		font-size: clamp(0.75rem, 1.4vw, 0.85rem);
		color: $silver;
	}

	/* 响应式设计 */
	@media (max-width: 1024px) {
		.partner-grid {
			grid-template-columns: repeat(4, 1fr);
			gap: 14px;
		}
	}

	@media (max-width: 768px) {
		.service-section {
			padding: 20px 0;
		}

		.partner-grid {
			grid-template-columns: repeat(3, 1fr);
			gap: 12px;
		}

		.partner-item {
			padding: 14px 8px;
		}

		.partner-logo {
			height: clamp(45px, 8vw, 55px);
		}

		.partner-name {
			font-size: 0.8rem;
		}
	}

	@media (max-width: 480px) {
		.partner-grid {
			grid-template-columns: repeat(3, 1fr);
			gap: 8px;
		}

		.partner-item {
			padding: 10px 6px;
			border-radius: 6px;
		}

		.partner-logo {
			height: 40px;
			margin-bottom: 6px;
		}

		.partner-name {
			font-size: 0.7rem;
		}
	}
</style>
